import { type PokerChoices } from '../components/facilitation/VotingSession/controllers/VotingSessionController';
import { type RecordId } from '../types';
import { type TimerStatus } from './TimerWidget';
import { type VotingSessionType } from './VotingSessionType';
import { type VotingSessionStatus } from './VotingSessionWidget';
import { type WidgetType as _WidgetType } from './widgetFromJSON';

// Re-export type from WidgetType because it reads better coming from
// here. See widgetFromJSON for a more detailed explanation.
export type WidgetType = _WidgetType;

export const commonSerializedKeys = ['id', 'authorId', 'type'] as const;

export interface BaseSerializedWidget {
  id?: RecordId;
  authorId?: RecordId;
  type: WidgetType;
}

export interface SerializedTimerWidget extends BaseSerializedWidget {
  type: 'TimerWidget';
  status: TimerStatus;
  startedAt: number | null;
  startDuration: number;
  exactDuration: number;
}

export interface SerializedVotingUserData {
  finishedVoting: boolean;
}

export interface SerializedVote {
  id: RecordId;
  type: 'Vote';
  votableId: RecordId;
  authorId: RecordId;
  createdAt: number | null;
  value?: number;
}

export interface SerializedVotingSessionWidget extends BaseSerializedWidget {
  type: 'VotingSessionWidget';
  name: string;
  status: VotingSessionStatus;
  startedAt: number | null;
  exactDuration: number | null;
  votableObjects?: { [votableId: RecordId]: boolean };
  currentVotingObject: {
    recordId: string;
    votingStatus: 'started' | 'finished';
  } | null;
  previousVotingObject: RecordId | undefined;
  userData?: {
    [authorId: RecordId]: SerializedVotingUserData;
  };
  sessionType: VotingSessionType;
  votesPerPerson?: number;
  votes?: {
    [authorId: RecordId]: { [voteId: RecordId]: SerializedVote | null };
  };
  pokerChoices?: PokerChoices;
  pokerFinalScores?: { [recordId: string]: string };
}

export type SerializedWidget =
  | SerializedTimerWidget
  | SerializedVotingSessionWidget;
